var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNeuro5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 460,
    viewBox: "0 0 1440 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_538_3508)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_3508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1444,
    height: 460
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1444 0H0V460H1444V0Z",
    fill: "#E9F4EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_3508)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M366.063 314.78L-14.3615 -65.6447C-33.8877 -85.1709 -65.5459 -85.1709 -85.0721 -65.6447L-427.646 276.929C-447.172 296.455 -447.172 328.113 -427.646 347.639L-47.2207 728.064C-27.6945 747.591 3.96376 747.591 23.49 728.064L366.063 385.491C385.59 365.965 385.59 334.306 366.063 314.78Z",
    fill: "#055094",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.063 319.78L-148.361 -60.6447C-167.888 -80.1709 -199.546 -80.1709 -219.072 -60.6447L-561.646 281.929C-581.172 301.455 -581.172 333.113 -561.646 352.639L-181.221 733.064C-161.694 752.591 -130.036 752.591 -110.51 733.064L232.063 390.491C251.59 370.965 251.59 339.306 232.063 319.78Z",
    fill: "#055094",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1508.61 -97.6761L1490.72 -115.574C1471.19 -135.1 1439.53 -135.1 1420 -115.574L1077.43 227C1057.91 246.526 1057.91 278.184 1077.43 297.71L1095.33 315.608C1114.86 335.134 1146.51 335.134 1166.04 315.608L1508.61 -26.9654C1528.14 -46.4916 1528.14 -78.1499 1508.61 -97.6761Z",
    fill: "#055094"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1740.29 -84.9882L1713.64 -111.645C1694.11 -131.171 1662.45 -131.171 1642.92 -111.645L1300.35 230.929C1280.83 250.455 1280.83 282.113 1300.35 301.639L1327.01 328.296C1346.53 347.822 1378.19 347.822 1397.72 328.296L1740.29 -14.2775C1759.82 -33.8037 1759.82 -65.4619 1740.29 -84.9882Z",
    fill: "#055094"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_538_3508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 460,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNeuro5);
export default __webpack_public_path__ + "static/media/bg-neuro5.d87c1250e8eaf9e4c607a8153beefa27.svg";
export { ForwardRef as ReactComponent };